// src/components/Roadmap.jsx
import React from "react";
import styled from "styled-components";
import { FaPlay, FaCode, FaProjectDiagram, FaRocket } from "react-icons/fa";
import { gradients } from "./theme/theme";

const Section = styled.section`
  padding: 6rem 2rem;
  background: ${gradients.heroBackground};
  text-align: center;
  color: #fff;
`;

const Title = styled.h2`
  font-size: 3rem;
  margin-bottom: 3rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const StepsWrapper = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  max-width: 1100px;
  margin: 0 auto;
`;

const StepCard = styled.div`
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(8px);
  padding: 2rem;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 25px rgba(255, 122, 24, 0.4);
  }
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: #ff7a18;
  margin-bottom: 1rem;
`;

const StepTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  color: #fff;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #ccc;
  line-height: 1.5;
`;

export default function Roadmap() {
  const steps = [
    {
      icon: <FaPlay />,
      title: "1. Start with Basics",
      desc: "Understand programming fundamentals, Git, and JavaScript basics to prepare for real-world projects.",
    },
    {
      icon: <FaCode />,
      title: "2. Learn Core Technologies",
      desc: "Dive into React, React Native, SQL, and Node.js through our practical, budget-friendly courses.",
    },
    {
      icon: <FaProjectDiagram />,
      title: "3. Build Real Projects",
      desc: "Apply your skills by building apps, websites, and backends — following real industry workflows.",
    },
    {
      icon: <FaRocket />,
      title: "4. Advance Your Career",
      desc: "Get mentorship, improve your portfolio, and prepare for job interviews or freelancing opportunities.",
    },
  ];

  return (
    <Section>
      <Title>🎯 Student Roadmap to Success</Title>
      <StepsWrapper>
        {steps.map((step, i) => (
          <StepCard key={i}>
            <IconWrapper>{step.icon}</IconWrapper>
            <StepTitle>{step.title}</StepTitle>
            <Description>{step.desc}</Description>
          </StepCard>
        ))}
      </StepsWrapper>
    </Section>
  );
}
